import React from 'react';
import ReactSelect from 'react-select';

const getCustomStyles = (size) => ({
  control: (provided, state) => ({
    ...provided,
    minHeight: size === 'sm' ? '36px' : '44px',
    height: size === 'sm' ? '36px' : undefined,
    borderRadius: '8px',
    borderColor: state.isFocused ? '#ee7923' : '#e2e8f0',
    boxShadow: state.isFocused ? '0 0 0 1px #ee7923' : 'none',
    '&:hover': {
      borderColor: '#ee7923'
    },
    fontFamily: 'inherit',
    fontSize: size === 'sm' ? '0.8125rem' : '0.875rem',
  }),
  valueContainer: (provided) => ({
    ...provided,
    ...(size === 'sm' ? { height: '36px', padding: '0 8px' } : {})
  }),
  input: (provided) => ({
    ...provided,
    ...(size === 'sm' ? { margin: '0px', padding: '0px' } : {})
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    ...(size === 'sm' ? { height: '36px' } : {})
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    ...(size === 'sm' ? { padding: '4px 6px' } : {})
  }),
  clearIndicator: (provided) => ({
    ...provided,
    ...(size === 'sm' ? { padding: '4px 6px' } : {})
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#ee7923' : state.isFocused ? '#f3f4f6' : 'white',
    color: state.isSelected ? 'white' : '#1f2937',
    fontSize: size === 'sm' ? '0.8125rem' : '0.875rem',
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: '8px',
    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
    zIndex: 50
  })
});

export const Select = ({
  options = [],
  value = '',
  onChange,
  placeholder = 'Select...',
  isDisabled = false,
  isSearchable = true,
  isClearable,
  size,
  name,
  id,
  required
}) => {
  const selectedOption = options.find(opt => opt.value === value) || null;

  const handleChange = (selected) => {
    if (onChange) {
      onChange(selected ? selected.value : '');
    }
  };

  const clearable = isClearable !== undefined ? isClearable : !required;

  return (
    <div className="relative w-full">
      <ReactSelect
        styles={getCustomStyles(size)}
        options={options}
        value={selectedOption}
        onChange={handleChange}
        placeholder={placeholder}
        isDisabled={isDisabled}
        isSearchable={isSearchable}
        isClearable={clearable}
        name={name}
        id={id}
      />
      {required && !value && (
        <input
          tabIndex={-1}
          autoComplete="off"
          style={{
            opacity: 0,
            width: '100%',
            height: 0,
            position: 'absolute',
            bottom: 0,
            left: 0
          }}
          value={value}
          onChange={() => {}}
          required={required}
        />
      )}
    </div>
  );
};
export default Select;
